'use client';

import React from 'react'

const leftImgClass = `w-[300px] h-[545px] rounded-3xl mr-4 
dd-2xl:w-[260px] dd-2xl:h-[386px] 
dd-xl:w-[146px] dd-xl:h-[299px]`
const rightTopImgClass = `w-[414px] h-[259px] gap-x-[16px] rounded-3xl mr-4 last:mr-0
dd-2xl:w-[306px] dd-2xl:h-[172px] 
dd-xl:w-[235px] dd-xl:h-[132px]`
const rightBottomImgClass = "w-full h-full"

const ImagesDekstop = () => {
  return (
    <div className='flex 
    dd-lg:hidden'>
      <div className={leftImgClass}>
        <img
          src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/main.png"}
          alt='Images'
          width="auto"
          height="auto"
          className='w-full h-full object-cover rounded-3xl'
        />
      </div>
      <div className='w-[844px] flex flex-col justify-between 
      dd-2xl:w-[628px] 
      dd-xl:w-[486px]'>
        <div className='mb-4 flex'>
          <div className={rightTopImgClass}>
            <img
              src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/2.png"}
              alt='Images'
              width="auto"
              height="auto"
              className='w-full h-full object-cover rounded-3xl'
            />
          </div>
          <div className={rightTopImgClass}>
            <img
              src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/3.png"}
              alt='Images'
              width="auto"
              height="auto"
              className='w-full h-full object-cover rounded-3xl'
            />
          </div>
        </div>

        <div className='grid w-full grid-cols-3 gap-x-[16px] h-[270px] 
        dd-2xl:h-[198px] 
        dd-xl:h-[151px]'>
          <div className={rightBottomImgClass}>
            <img
              src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/4.png"}
              alt='Images'
              width="auto"
              height="auto"
              className='w-full h-full object-cover rounded-3xl'
            />
          </div>
          <div className={rightBottomImgClass}>
            <img
              src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/5.png"}
              alt='Images'
              width="auto"
              height="auto"
              className='w-full h-full object-cover rounded-3xl'
            />
          </div>
          <div className={rightBottomImgClass}>
            <img
              src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/6.png"}
              alt='Images'
              width="auto"
              height="auto"
              className='w-full h-full object-cover rounded-3xl'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImagesDekstop